import { parseShopifyGid } from '../../../lib/shopify/shopifyGid';

// #742: builds the GA4 `view_cart` ecommerce payload for the new cart drawer.
// Reads the Storefront cart line shape (`node.merchandise`), unlike the legacy
// useViewCartTracking which expected `node.variant` and silently no-op'd here.
const categoriesFor = (handle, contentfulData) => {
  const productSpecs = contentfulData?.find(c => c?.slug === handle)?.productSpecsCollection?.items;
  if (!productSpecs) return {};

  const valueFor = filterTypes =>
    productSpecs.find(({ type }) => filterTypes.includes(type?.filterType))?.value;

  const productType = valueFor(['Producttype', 'Type de produit', 'Product type']);
  const productCategory = valueFor([
    'Productcategorie',
    'Catégorie de produit',
    'Product Category',
  ]);
  const productSubCategory = valueFor(['Subcategorie', 'Sous-catégorie', 'Sub Category']);

  return {
    ...(productType && { item_category: productType }),
    ...(productCategory && { item_category2: productCategory }),
    ...(productSubCategory && { item_category3: productSubCategory }),
  };
};

export function buildViewCartEcommerce({
  currencyCode,
  lineItems = [],
  contentfulData = [],
  trackedItemsSelectList = [],
}) {
  return {
    currency: currencyCode,
    items: lineItems.map(({ node }) => {
      const { merchandise, quantity } = node || {};
      const product = merchandise?.product;
      const itemId = parseShopifyGid(product?.id);
      const itemListName = trackedItemsSelectList?.find(p => p?.productId === itemId)?.itemListName;

      return {
        item_name: product?.title,
        item_id: itemId,
        price: merchandise?.priceV2?.amount,
        item_brand: 'Keune',
        ...categoriesFor(product?.handle, contentfulData),
        quantity,
        item_list_name: itemListName,
      };
    }),
  };
}

export default buildViewCartEcommerce;
